import { useMemo } from 'react';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';
import {
  getmaxAnswerableQuestions,
  getAllAnswersBySection,
  getAllMarkedQuestions,
  getUnansweredQuestions
} from '@selectors/quizTaking';
import { getNtaSectionCounts } from '../ntaSectionCounts';

const useNtaPaletteCounts = (sectionUID) => {
  const answersBySection = useSelectorWithShallowEqual(getAllAnswersBySection);
  const maxAnswerableQuestionBySection = useSelectorWithShallowEqual(
    getmaxAnswerableQuestions
  );
  const markedQuestionsBySection = useSelectorWithShallowEqual(
    getAllMarkedQuestions
  );
  const unansweredQuestionsBySection = useSelectorWithShallowEqual(
    getUnansweredQuestions
  );

  return useMemo(
    () =>
      getNtaSectionCounts(sectionUID, {
        answersBySection,
        maxAnswerableQuestionBySection,
        markedQuestionsBySection,
        unansweredQuestionsBySection
      }),
    [
      answersBySection,
      markedQuestionsBySection,
      maxAnswerableQuestionBySection,
      sectionUID,
      unansweredQuestionsBySection
    ]
  );
};

export default useNtaPaletteCounts;
